<template>
  <div class="member-management-system">
    <Header :messageList="messageList" />
    <!-- 搜索框 -->
    <!-- <div class="search-container">
      <van-search v-model="search" show-action placeholder="搜索会员姓名或编号" @search="onSearch">
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div> -->
    <div style="padding: 15px 15px 0 15px; background-color: #79beff;">
      <div style="position: relative; padding: 10px; border: 2px solid #fff; border-radius: 15px 15px 0 0; border-bottom: none; display: flex; align-items: center; justify-content: space-between; background-color: #93c9fc;">
        <img style="position: absolute; left: 0; bottom: 0; width: 300px; height: 100px;" src="@/assets/img/user_bg.png" alt="">
        <div style="font-size: 18px; font-weight: 700; width: 60vw;">{{ cloud.realName }}</div>
        <div style="background-color: #fff; border-radius: 50%; padding: 15px; width: 80px; height: 80px; box-sizing: border-box;  "><img src="@/assets/img/mendian.png" style="width: 50px; height: 50px;" alt="" srcset=""></div>
      </div>
    </div>
    <div style="padding: 8px 12px; background-color: #fff; display: flex;align-items: center; justify-content: space-around; color: #999; font-size: 12px; ">
      <div style="display: flex;align-items: center;">
        <div>①</div>
        <div style="margin-left: 5px;">选择审方类型</div>
      </div>
      <div> <van-icon name="arrow" /> </div>
      <div style="display: flex;align-items: center;">
        <div>②</div>
        <div style="margin-left: 5px;">提交信息</div>
      </div>
      <div> <van-icon name="arrow" /> </div>
      <div style="display: flex;align-items: center;">
        <div>③</div>
        <div style="margin-left: 5px;">审核处方</div>
      </div>
    </div>
    <div style="padding: 10px;">
      <van-cell title="审方列表" is-link @click="handleRecordList" />
      <div class="stats-cards">
        <div class="stat-card">
          <div class="stat-number">{{ statisticsData.allCount || 0 }}</div>
          <div class="stat-label">今日审方</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">{{ statisticsData.mtCount || 0 }}</div>
          <div class="stat-label">580审方</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">{{ statisticsData.actCount || 0 }}</div>
          <div class="stat-label">自主审方</div>
        </div>
        <!-- <div class="stat-card">
                  <div class="stat-number">92%</div>
                  <div class="stat-label">完成率</div>
              </div> -->
      </div>
      <!-- 会员列表 -->
      <h2 class="section-title" style="margin-top: 20px;">
        <i class="fas fa-users"></i>
        审方类型
      </h2>

      <div>
        <div style="display: flex; align-items: center;justify-content: space-around; ">
          <!-- <button class="prescription-btn btn-580" @click="prescription580(member)">
            <i class="fas fa-bolt"></i> 580开方
          </button>
          <button class="prescription-btn btn-self" @click="selfPrescription(member)">
            <i class="fas fa-user-edit"></i> 自主开方
          </button> -->
          <div class="prescription-box btn-580" @click="prescription580">
            <div> <i class="fas fa-bolt"></i></div>
            <div>580审方</div>
          </div>

          <div class="prescription-box btn-self" @click="selfPrescription">
            <div> <i class="fas fa-user-edit"></i></div>
            <div>自主审方</div>
          </div>

        </div>
      </div>
    </div>
    <!-- 统计卡片 -->
    

    <!-- <van-pull-refresh  v-model="loading" class="refresh-container" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad">
        <div v-if="list.length > 0">
          <div class="member-card" v-for="member in list" :key="member.id">
            <div class="member-info">
              <div class="member-avatar" v-if="member.contact != null">
                {{ member.contact.charAt(0) }}
              </div>
              <div class="member-avatar" v-else>
                {{ member.contact }}
              </div>
              <div class="member-details">
                <div class="member-name">
                  {{ member.name }}
                  <span class="member-contact">姓名: {{ member.contact }}</span>
                </div>
                <div class="member-name">
                  {{ member.name }}
                  <span class="member-id">编号: {{ member.contactcode }}</span>
                </div>
                <div class="member-phone">
                  <i class="fas fa-phone"></i> {{ member.mobile }}
                </div>

                <div class="member-meta">
                  <div class="meta-item">
                    <i class="fas fa-venus-mars"></i>
                    性别: {{ member.gender == 'F' ? '女' : '男' }}
                  </div>
                  <div class="meta-item">
                    <i class="fas fa-stethoscope"></i>
                    身份证: {{ member.idcard }}
                  </div>
                </div>
              </div>
              <div class="button-group">
                <button class="prescription-btn btn-580" @click="prescription580(member)">
                  <i class="fas fa-bolt"></i> 580开方
                </button>
                <button class="prescription-btn btn-self" @click="selfPrescription(member)">
                  <i class="fas fa-user-edit"></i> 自主开方
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="fas fa-user-slash"></i>
          <p>暂无会员数据</p>
        </div>
      </van-list>
    </van-pull-refresh> -->
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import { getlogin, getMember, getStatistics, getPresLog, getOneLog } from '@/api/user'
import { Toast,Icon, Notify } from 'vant'

export default {
  name: 'Home',
  components: {
    Header
  },
  data() {
    return {
      storeid: "",
      search: '',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 10,
      cloud: {},
      statisticsData: {},
      messageList: 0,
      timeFun: null,
    }
  },
  async created() {
    let _this=this;
    this.storeid = this.getHashParameters('storeid');
    localStorage.setItem('storeid', this.storeid);
    let cloudResult = await getlogin({ storeid: this.storeid });
    this.cloud = cloudResult.data
   
    localStorage.setItem('cloud', JSON.stringify(this.cloud));
    localStorage.setItem('token', this.cloud.token);
    console.log("云通信数据" + JSON.stringify(this.cloud))
    

  },
  computed: {
    finishedText() {
      return this.list.length > 0 ? "没有更多了" : "";
    }
  },
  mounted() {
    getStatistics({
      storeid:this.storeid,
    }).then(res => {
      this.statisticsData = res.data
    })

    this.getMessage()
    this.timeFun = setInterval(() => {
      this.getMessage()
    }, 10000);

  },
  beforeDestroy() {
    clearInterval(this.timeFun)
  },
  methods: {
    getMessage() {
      getOneLog({
          id: this.storeid,
      }).then(res => {
          if(res.data) {
            this.messageList =res.data.unread
            if(res.data.status == 1) {
              Notify({ type: 'danger', duration: 4000, message: `${res.data.createTime}  患者: ${res.data.username} 的${res.data.type == 0 ? '580':'自主'}处方未通过审核，请到消息列表${res.data.type == 0 ? '580':'自主'}审方中查看!` });
            } else {
              Notify({ type: 'success', duration: 4000, message: `${res.data.createTime}  患者: ${res.data.username} 的${res.data.type == 0 ? '580':'自主'}处方已通过审核，请到消息列表${res.data.type == 0 ? '580':'自主'}审方中查看!` });
            }
          }
      })
    },
    //获取url链接参数
    getHashParameters(obj) {
      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash.split('?')[1] || '');
      const result = {};
      for (let [key, value] of params) {
        result[key] = value;
      }
      return result[obj];
    },
    async onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      let params = {
        keywords: this.search,
        page: this.page,
        limit: this.pageSize
      }
      getMember(params).then(result => {
        this.list = this.list.concat(result.data.list)
        this.loading = false;
        this.page = this.page + 1;
        // 数据全部加载完成
        if (this.list.length >= result.data.total) {
          this.finished = true;
        }
      });
      // console.log("返回的数据" + JSON.stringify(result))

    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.list = [];
      this.page = 1;
      this.onLoad();
    },
    onSearch() {
      this.list = [];
      this.page = 1;
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    //跳转580审方
    prescription580(member) {
      // let contact = member.contact
      let storeid = this.storeid
      let activeTab = "580consultation";
      if (this.cloud.wyKey && this.cloud.wyToken) {
        // localStorage.setItem('userInfo', JSON.stringify(member));
        this.$router.push({ name: 'Prescription', query: { activeTab } })
      } else {
        Toast.fail('云通信登录失败')
      }
    },
    //跳转自主审方
    selfPrescription(member) {
      // localStorage.setItem('userInfo', JSON.stringify(member));
      // Toast.fail('功能暂不可用')
      // return
      let activeTab = "consultation"
      this.$router.push({ name: 'Detail', query: { activeTab } })
    },
    handleRecordList() {
      this.$router.push({ name: 'record' })
    }
  },
}
</script>

<style scoped>
.member-management-system {
  /* width:100%; */
  margin: 0 auto;
  font-family: 'Noto Sans SC', sans-serif;
}

.header {
  background: linear-gradient(135deg, #4a90e2 0%, #346abf 100%);
  color: white;
  padding: 20px;
  border-radius: 0 0 15px 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
}

.logo i {
  margin-right: 10px;
  font-size: 26px;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}

.headers {
  padding: 20px;
}

.search-box {
  border-radius: 0px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.stats-cards {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  overflow-x: auto;
  padding: 5px 0;
  scrollbar-width: none;
  margin-top: 10px
}

.stats-cards::-webkit-scrollbar {
  display: none;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 15px;
  min-width: 120px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  text-align: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.stat-card:last-child {
  margin-right: 0;
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 5px;
}

.stat-card:nth-child(1) .stat-number {
  color: #4a90e2;
}

.stat-card:nth-child(2) .stat-number {
  color: #ff6b6b;
}

.stat-card:nth-child(3) .stat-number {
  color: #4fc08d;
}

.stat-card:nth-child(4) .stat-number {
  color: #ff9f43;
}

.stat-label {
  font-size: 12px;
  color: #777;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0px 0 15px;
  color: #344a5f;
  display: flex;
  align-items: center;
}

.section-title i {
  margin-right: 8px;
  color: #4fc08d;
}

.member-card {
  border-radius: 16px;
  margin-bottom: 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  /* transition: transform 0.3s ease, box-shadow 0.3s ease; */
  background: white;
}

.member-card:hover {
  /* transform: translateY(-5px); */
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.1);
}

.member-info {
  display: flex;
  align-items: center;
  padding: 20px;
}

.member-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4fc08d 0%, #348f50 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 24px;
  margin-right: 18px;
  flex-shrink: 0;
}

.member-details {
  flex: 1;
}

.member-name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #2c3e50;
  display: flex;
  align-items: center;
}

.member-contact {
  font-size: 14px;
  color: #7f8c8d;
  margin-left: 10px;
  font-weight: bold;
}

.member-id {
  font-size: 12px;
  color: #7f8c8d;
  margin-left: 10px;
  font-weight: normal;
}

.member-phone {
  color: #7f8c8d;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.member-phone i {
  margin-right: 8px;
  color: #4fc08d;
}

.member-meta {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.meta-item {
  display: flex;
  align-items: center;
  margin-right: 15px;
  margin-bottom: 8px;
  font-size: 13px;
  color: #5a6c7d;
}

.meta-item i {
  margin-right: 5px;
}

.meta-item:nth-child(1) i {
  color: #4a90e2;
}

.meta-item:nth-child(2) i {
  color: #ff6b6b;
}

.meta-item:nth-child(3) i {
  color: #4fc08d;
}

.member-tags {
  display: flex;
  margin-top: 5px;
}

.member-tag {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
  margin-right: 8px;
  font-weight: 500;
}

.tag-balance {
  background-color: #e6f7ff;
  color: #1890ff;
}

.tag-credit {
  background-color: #fff0e6;
  color: #ff7733;
}

.tag-status {
  background-color: #f6ffed;
  color: #52c41a;
}

.button-group {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}
.prescription-box {
  width: 40vw; 
  height: 100px; 
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.prescription-btn {
  border-radius: 25px;
  border: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 10px 15px;
  margin-bottom: 15px;
  font-weight: 500;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  transition: all 0.3s ease;
  width: 80vw;
  margin-left: calc(10vw - 10px);
  margin-top: 15px;

}

.prescription-btn:last-child {
  margin-bottom: 0;
}

.prescription-btn i {
  margin-right: 5px;
}

.btn-580 {
  background: linear-gradient(135deg, #ff9f43 0%, #ff7f00 100%);
  color: white;
  box-shadow: 0 0 3px #ff7f00;
}

.btn-580:hover {
  background: linear-gradient(135deg, #ff7f00 0%, #ff6b00 100%);
  box-shadow: 0 6px 12px rgba(255, 159, 67, 0.3);
}

.btn-self {
  background: linear-gradient(135deg, #4fc08d 0%, #3bac7d 100%);
  color: white;
  box-shadow: 0 0 3px #3bac7d;
}

.btn-self:hover {
  background: linear-gradient(135deg, #3bac7d 0%, #349e70 100%);
  box-shadow: 0 6px 12px rgba(79, 192, 141, 0.3);
}

.empty-state {
  text-align: center;
  padding: 50px 0;
  color: #bdc3c7;
}

.empty-state i {
  font-size: 70px;
  margin-bottom: 20px;
  opacity: 0.7;
}

.empty-state p {
  font-size: 16px;
  margin-top: 10px;
}

.loading-text {
  text-align: center;
  padding: 20px;
  color: #7f8c8d;
}

.finished-text {
  text-align: center;
  padding: 20px;
  color: #95a5a6;
  font-size: 14px;
}

.refresh-container {
  overflow: hidden;
  border-radius: 0 0 16px 16px;
}

@media (max-width: 600px) {
  .member-info {
    padding: 15px;
    flex-wrap: wrap;
  }

  .member-avatar {
    width: 50px;
    height: 50px;
    font-size: 20px;
    margin-right: 15px;
  }

  .member-name {
    font-size: 16px;
  }

  .button-group {
    flex-direction: row;
    width: 100%;
    margin-top: 15px;
    margin-left: 0;
  }

  .prescription-btn {
    /* flex: 1;
    margin: 0 5px;
    min-width: auto; */
  }

  .stat-card {
    min-width: 90px;
    padding: 12px;
  }

  .stat-number {
    font-size: 20px;
  }

  .meta-item {
    font-size: 12px;
    margin-right: 10px;
  }
}
</style>